import React, { memo, forwardRef } from "react";
const SvgAlphabetH = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.02 18.28c0-.28-.02-.567-.06-.86a2.28 2.28 0 00-.26-.82c-.12-.253-.3-.46-.54-.62-.227-.16-.533-.24-.92-.24s-.72.073-1 .22c-.28.147-.513.347-.7.6-.187.24-.327.513-.42.82-.093.307-.14.62-.14.94v4.08c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7V9.6c0-.28.04-.507.12-.68.093-.187.2-.327.32-.42.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v5.7h.04c.093-.2.227-.393.4-.58.187-.2.4-.373.64-.52.24-.16.513-.287.82-.38.307-.093.64-.14 1-.14.627 0 1.16.113 1.6.34.453.213.82.5 1.1.86.293.36.507.773.64 1.24.133.467.2.947.2 1.44v4.84c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-4.12z"
      />
    </svg>
  );
});
SvgAlphabetH.displayName = "SvgAlphabetH";
const MemoForwardRef = memo(SvgAlphabetH);
export default MemoForwardRef;
